import Component from './menu'

export default Component